// @flow
import { type DocumentNode } from 'graphql';
import { useApolloClient } from '@apollo/client';
// $FlowFixMe - Cannot import useState because there is no useState export in react.
import { useState, useEffect, type Node } from 'react';

type SequentialQueriesProps = {
  children: ({ data: ?Array<Object>, error: string, loading: boolean }) => Node,
  queries: Array<{ query: DocumentNode, variables: Object }>,
};

const SequentialQueries = ({ children, queries }: SequentialQueriesProps) => {
  const [queryData, setQueryData] = useState();
  const [queryError, setQueryError] = useState();
  const [loading, setLoading] = useState(false);
  const { query: apolloQuery } = useApolloClient();

  useEffect(() => {
    const datasets = new Map();
    setLoading(true);
    Promise.all(queries.map(queryParam => apolloQuery(queryParam)))
      .then(results => {
        setQueryData(
          Array.from(
            results.reduce((memo, { data }) => {
              const key = Object.keys(data)[0];
              if (!datasets.get(key)) {
                datasets.set(key, data[key]);
              } else {
                // $FlowFixMe
                datasets.set(key, [...datasets.get(key), ...data[key]]);
              }
              return datasets;
            }, datasets),
          ),
        );
      })
      .catch(error => setQueryError(error))
      .finally(() => setLoading(false));
  }, [apolloQuery, queries]);

  if (!queries || !queries.length) {
    return children({
      data: undefined,
      error: 'Something went wrong. No queries were received. Please try again.',
      loading: false,
    });
  }

  if (!queryData) return null;

  return children({ data: queryData, loading, error: queryError && queryError });
};

export default SequentialQueries;
